/**
 * `item.path` (`/‹uuid›/‹uuid›/`) dan JORIY bo'limning ajdodlari nomini
 * yo'l tartibida chiqaradi — `DepartmentsExplorerTable` tekis qidiruv
 * subtitle'i uchun (spec §9). Oxirgi segment DOIM joriy bo'limning O'ZI,
 * shuning uchun u chiqarib tashlanadi.
 *
 * ⚠️ `nameById` — `GET /departments` (doiraga qarab filtrlangan) dan
 * qurilgan id→nom xaritasi. Xaritada topilmagan id (masalan bo'lim bo'yicha
 * cheklangan menejer o'z ildizidan yuqoridagi ajdodni ko'rmaydi) JIMGINA
 * o'tkazib yuboriladi — `undefined` chizilmaydi.
 */
export function departmentAncestorNames(path: string, nameById: Map<string, string>): string[] {
	const ids = path.split("/").filter((segment) => segment.length > 0);
	const ancestorIds = ids.slice(0, -1);

	return ancestorIds
		.map((id) => nameById.get(id))
		.filter((name): name is string => typeof name === "string");
}
